import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';

export const getRawCurrentLaborTicket = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    // Split raw vs filtered access because synthetic selectors still need CLOSED ticket data.
    return workOrderManagement?.currentLaborTicket;
  }
);

/**
 * Gets the current labor ticket for the active machine.
 * This is scoped to the current machine via the subscription filter in useRealTimeData.
 * For clock-out flow across all machines, use getClockOutOpenLaborTicketCount instead.
 */
export const getCurrentLaborTicket = createSelector(
  [getRawCurrentLaborTicket, getPostLaborUpdatesOnNats],
  (currentLaborTicket, postLaborUpdatesOnNats) => {
    if (currentLaborTicket?.state === 'CLOSED') {
      const endBehavior = currentLaborTicket?.customFields?.endBehavior;
      // keep-open only applies in the NATS labor-updates flow (not MES / standard ERP)
      // Hide other CLOSED tickets here instead of in Redux so raw consumers can still read the subscription payload.
      if (!(postLaborUpdatesOnNats && endBehavior === 'keep-open')) {
        return null;
      }
    }

    return currentLaborTicket;
  }
);
